// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"7148ca84","173":"37a3444a","356":"39ea0f0b","456":"2b5e429d","470":"eee5c05e","567":"eb8a93a6"}[chunkId] + ".chunk.js";
};